import { Colors, list as degreeList } from '@goodfellas/graduation'

type BeltObjectLike = {
  color?: unknown
  degree?: unknown
}

function toKebabCase(input: string): string {
  return input
    .trim()
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/_/g, '-')
    .replace(/\s+/g, '-')
    .toLowerCase()
}

export function normalizeBeltColor(input: unknown): Colors | '' {
  if (input == null) return ''

  // Support legacy profile format: { color, degree }
  if (typeof input === 'object') {
    const obj = input as BeltObjectLike
    if (obj?.color != null) return normalizeBeltColor(obj.color)
  }

  const raw = String(input).trim()
  if (!raw) return ''
  const normalized = toKebabCase(raw)
  const values = Object.values(Colors) as string[]
  return values.includes(normalized) ? (normalized as Colors) : ''
}

export function normalizeDegree(color: Colors | '', degree: unknown): number {
  const degreeRaw = Number(degree)
  const d = Number.isFinite(degreeRaw) ? Math.trunc(degreeRaw) : 0
  if (!color) return Math.max(0, d)

  const allowed = degreeList[color as Colors] as readonly number[] | undefined
  if (!allowed || allowed.length === 0) return Math.max(0, d)
  return allowed.includes(d) ? d : allowed[0] ?? 0
}

export function normalizeUserGraduation(input: {
  belt?: unknown
  degree?: unknown
}): { belt: Colors | ''; degree: number } {
  const belt = normalizeBeltColor(input.belt)

  // Support legacy profile format: belt.degree can be the source of truth
  const beltObj =
    input.belt && typeof input.belt === 'object'
      ? (input.belt as BeltObjectLike)
      : undefined
  const degreeSource = beltObj?.degree ?? input.degree

  const degree = normalizeDegree(belt, degreeSource)
  return { belt, degree }
}
